import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { FaBolt, FaMinus, FaPlus } from 'react-icons/fa6';

import { Box, Chip, Grid2, IconButton, Input, Typography } from '@mui/material';

import { ButtonColor } from 'shared/Button';
import { GetProductsData } from 'types/api/api-products.types';

interface DeviceControlProps {
  quantity?: number;
  miner: GetProductsData.Product | null;
  ableToDelete?: boolean;
  setItemQuantity: Dispatch<SetStateAction<number>>;
}

export const DeviceInfoBlock: React.FC<DeviceControlProps> = ({ quantity, miner, ableToDelete, setItemQuantity }) => {
  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    let value = Number(e.target.value);

    if (isNaN(value) || value < 1) value = 1;

    setItemQuantity(value);
  };

  const decrementCount = () => {
    setItemQuantity(prev => Math.max(prev - 1, 1));
  };

  const incrementCount = () => {
    setItemQuantity(prev => prev + 1);
  };

  return (
    <Grid2 container spacing={2} direction='column'>
      {/* Title and Additional Info Row */}
      <Grid2 size={12} container justifyContent='space-between' alignItems='center'>
        <Grid2>
          <Box>
            {miner?.topSeller && <Chip label='Top Seller' color={ButtonColor.DEFAULT} size='small' />}
            <Typography variant='h2'>
              {miner?.manufacturer} {miner?.model}
            </Typography>
          </Box>
          <Box display='flex' justifyItems='center' alignItems='center' mt={1}>
            <Box mr={1} component='span'>
              <FaBolt size={18} />
            </Box>
            <Box component='span'>
              <Typography>
                {miner?.terahashes} TH/s - {miner?.wattage} Watt
              </Typography>
            </Box>
          </Box>
        </Grid2>
        {/* <Grid2>
          {ableToDelete && (
            <Tooltip title='Remove from basket' arrow>
              <IconButton aria-label='delete' size='large'>
                <FaTrash />
              </IconButton>
            </Tooltip>
          )}
        </Grid2> */}
      </Grid2>

      {/* Quantity Control Row */}
      <Grid2 size={12} container alignItems='center' spacing={1}>
        <Grid2 container alignItems='center'>
          <IconButton
            onClick={decrementCount}
            disabled={quantity ? quantity <= 1 : true}
            sx={{
              borderRadius: 1,
            }}
          >
            <FaMinus />
          </IconButton>

          <Input
            type='number'
            value={quantity}
            onChange={changeHandler}
            inputProps={{
              style: {
                textAlign: 'center',
                fontSize: '2rem',
                lineHeight: '3rem',
                padding: 0,
                borderRadius: 0,
                borderWidth: 0,
                outlineWidth: 0,
              },
            }}
            sx={{
              width: 80,
            }}
          />

          <IconButton
            onClick={incrementCount}
            sx={{
              borderRadius: 1,
              backgroundColor: 'transparent',
              padding: 0,
              width: 40,
              height: 40,
            }}
          >
            <FaPlus />
          </IconButton>
        </Grid2>
        <Grid2>
          <Typography variant='body1'>number of devices</Typography>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};
